import React from 'react'
import mixpanel from '@disco/api/mixpanel'
import { getTrialLeft } from '@disco/utils/trial'
import Button from 'components/ui/button'
import Header from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import Stack from 'components/ui/stack'
import Text from 'components/ui/text'
type Props = {
  trialEnd: number
}

const TrialExpiredModal = (props: Props): null | React.ReactNode => {
  const onClick = () => {
    mixpanel.sendPureEvent('Open Billing via trial prompt (user click)')
  }

  const { expired } = getTrialLeft(props.trialEnd, 'short')
  if (!expired) return null
  return (
    <ModalWindow
      header={<Header size={700}>Trial expired</Header>} // this modal can't be closed
      onClose={() => {}}
      hiddenCloseButton
      isOpen
    >
      <Stack space="small">
        <Text type="paragraph">
          Your DISCO trial has expired. To continue using DISCO, subscribe to
          one of our plans.
        </Text>
        <Button
          onClick={onClick}
          link="/settings/billing"
          appearance="primary"
          caption="View plans and pricing"
          fullWidth
          textCenter
        />
      </Stack>
    </ModalWindow>
  )
}

export default TrialExpiredModal
